import { render } from "./aio-login-turnstile-card.vue?vue&type=template&id=441acd16&scoped=true"
import script from "./aio-login-turnstile-card.vue?vue&type=script&lang=js"
export * from "./aio-login-turnstile-card.vue?vue&type=script&lang=js"

import "./aio-login-turnstile-card.vue?vue&type=style&index=0&id=441acd16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441acd16"]])

export default __exports__